import React, { FC } from 'react';

const ResetPasswordPage: FC = () => <div>Reset password</div>;

export default ResetPasswordPage;
